import { type SupportedActivityEvent } from '../activities'

interface ActivitiesEn {
  descriptions: Record<SupportedActivityEvent, string>
}

export const activitiesEn: ActivitiesEn = {
  descriptions: {
    'auth:otp-code-revealed': 'revealed an OTP code',
    'billing:invoice-payment-failed': 'subscription payment failed',
    'billing:invoice-payment-succeeded': 'collected subscription payment',
    'billing:subscription-cancelled': 'cancelled subscription',
    'billing:subscription-created': 'created new subscription',
    'billing:subscription-tier-updated': 'updated subscription tier',
    'brand-status:workflow-completed': 'completed setup step',
    'checkout:busy-kitchen-disabled': 'set normal prep time',
    'checkout:busy-kitchen-enabled': 'set busy prep time',
    'checkout:kitchen-capacity-schedule-updated':
      'updated kitchen capacity schedule',
    'checkout:olo-settings-updated': 'updated OLO settings',
    'checkout:scheduled-orders-disabled': 'disabled scheduled orders',
    'checkout:scheduled-orders-enabled': 'enabled scheduled orders',
    'checkout:store-paused': 'paused online ordering',
    'checkout:store-unpaused': 'resumed online ordering',
    'checkout:throttle-counters-cleared': 'cleared throttle counters',
    'customer:customer-list-imported': 'imported customer list',
    'delivery:delivery-disabled': 'disabled delivery',
    'delivery:delivery-enabled': 'enabled delivery',
    'delivery:delivery-settings-updated': 'updated delivery settings',
    'domain:dns-type-changed': 'changed DNS type',
    'domain:record-added': 'added domain record',
    'domain:record-changed': 'changed domain record',
    'domain:record-deleted': 'deleted domain record',
    'domain:remote-dns-vendor-changed': 'changed remote DNS vendor',
    'domain:requested-domain-verification': 'requested domain verification',
    'domain:template-added': 'added domain template',
    'domain:template-changed': 'changed domain template',
    'domain:template-deleted': 'deleted domain template',
    'google:brand-gbp-grant-created': 'created brand GBP grant',
    'google:location-gbp-invitation-accepted':
      'accepted location GBP invitation',
    'google:location-gbp-invitation-sent': 'sent location GBP invitation',
    'hestia:user-logged-in': 'logged in to Owner App',
    'launch:domain-information-submitted': 'submitted domain information',
    'launch:launch-type-updated': 'updated launch type',
    'launch:olo-launched': 'launched Owner OLO',
    'launch:onboarding-step-skipped': 'skipped onboarding step',
    'launch:pos-call-booking-updated': 'updated POS sync call booking',
    'launch:pos-selection-submitted': 'submitted POS selection',
    'launch:pre-consultation-info-submitted':
      'submitted pre-consultation information',
    'menu:category-availability-toggled': 'toggled category availability',
    'menu:category-created': 'created a category',
    'menu:category-created-brand': 'created a category',
    'menu:category-deleted': 'deleted a category',
    'menu:category-deleted-brand': 'deleted a category',
    'menu:category-updated': 'updated a category',
    'menu:category-updated-brand': 'updated a category',
    'menu:coupon-availability-toggled': 'toggled coupon availability',
    'menu:coupon-created': 'created a coupon',
    'menu:coupon-created-brand': 'created a coupon',
    'menu:coupon-deleted': 'deleted a coupon',
    'menu:coupon-deleted-brand': 'deleted a coupon',
    'menu:coupon-updated': 'updated a coupon',
    'menu:coupon-updated-brand': 'updated a coupon',
    'menu:item-availability-toggled': 'toggled item availability',
    'menu:item-created': 'created a menu item',
    'menu:item-created-brand': 'created a menu item',
    'menu:item-deleted': 'deleted a menu item',
    'menu:item-deleted-brand': 'deleted a menu item',
    'menu:item-updated': 'updated a menu item',
    'menu:item-updated-brand': 'updated a menu item',
    'menu:menu-availability-toggled': 'toggled menu availability',
    'menu:menu-created': 'created a menu',
    'menu:menu-created-brand': 'created a menu',
    'menu:menu-deleted': 'deleted a menu',
    'menu:menu-deleted-brand': 'deleted a menu',
    'menu:menu-updated': 'updated a menu',
    'menu:menu-updated-brand': 'updated a menu',
    'menu:menus-cloned': 'cloned menus to locations',
    'menu:modifier-availability-toggled': 'toggled option availability',
    'menu:modifier-created': 'created an option',
    'menu:modifier-created-brand': 'created an option',
    'menu:modifier-deleted': 'deleted an option',
    'menu:modifier-deleted-brand': 'deleted an option',
    'menu:modifier-set-availability-toggled':
      'toggled option group availability',
    'menu:modifier-set-created': 'created an option group',
    'menu:modifier-set-created-brand': 'created an option group',
    'menu:modifier-set-deleted': 'deleted an option group',
    'menu:modifier-set-deleted-brand': 'deleted an option group',
    'menu:modifier-set-updated': 'updated an option group',
    'menu:modifier-set-updated-brand': 'updated an option group',
    'menu:modifier-updated': 'updated an option',
    'menu:modifier-updated-brand': 'updated an option',
    'mobile-app:app-store-listing-delisted': 'mobile app delisted from store',
    'mobile-app:app-store-listing-launched': 'mobile app launched on store',
    'partner:cuisines-updated': 'updated brand cuisines',
    'partner:dine-in-disabled': 'disabled dine-in',
    'partner:dine-in-enabled': 'enabled dine-in',
    'partner:identity-verification-attempted': 'started identity verification',
    'partner:identity-verification-status-changed':
      'identity verification status changed',
    'partner:location-address-changed': 'updated location address',
    'partner:location-status-updated': 'updated location status',
    'partner:online-hours-buffer-updated': 'updated online hours',
    'partner:online-hours-custom-updated': 'updated online hours',
    'partner:online-hours-mapping-changed': 'update online hours',
    'partner:owner-fee-settings-updated': 'updated owner fee settings',
    'partner:pickup-disabled': 'disabled pickup',
    'partner:pickup-enabled': 'enabled pickup',
    'partner:processing-settings-updated': 'updated processing settings',
    'partner:special-hours-created': 'created special hours',
    'partner:special-hours-deleted': 'deleted special hours',
    'partner:special-hours-updated': 'updated special hours',
    'partner:store-hours-updated': 'updated store hours',
    'registrar:domain-registered': 'registered domain',
    'registrar:domain-transfer-started': 'started domain transfer',
    'sales:purchase-type-updated': 'updated purchase type',
    'scout:generation-triggered': 'triggered Scout website generation',
    'scout:website-imported': 'imported Scout-generated website',
    'virtualcards:card-created': 'created virtual card',
    'virtualcards:card-details-viewed': 'viewed card details',
    'virtualcards:card-state-changed': 'changed card state',
    'virtualcards:card-transaction-received': 'received transaction',
    'website:spec-exported': 'exported website spec',
    'website:spec-imported': 'imported website spec',
  },
}
